import numeral from 'numeral';

import getNumberFormats from '@/helpers/numberFormats';

const NumbersPlugin = {
    install(app) {
        const numberFormats = getNumberFormats();
        app.config.globalProperties.$numberFormats = numberFormats;
        const numberFormatsAbbr = getNumberFormats(true);
        app.config.globalProperties.$numberFormatsAbbr = numberFormatsAbbr;
        app.config.globalProperties.$formatNumber = (number, format = numberFormats.decimal) => {
            return numeral(number).format(format);
        };
    },
};

export default NumbersPlugin;
